import React from "react";
import OpeningHours from "../../Images/Rimberio Salon.png";

function WorkingHours() {
  return (
    <section>
      <div>
        <img src={OpeningHours} alt="" style={{ width: "100%" }} />
      </div>
    </section>
  );
}

export default WorkingHours;
